import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const PrivateBathroomIcon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "PrivateBathroomIconGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}
      <path
        d="M22.7987 12.3011C22.7987 12.0263 22.5758 11.8034 22.3011 11.8034H15.6395C16.8157 11.053 17.6025 9.7444 17.6025 8.24878C17.6025 5.91983 15.7082 4.02557 13.3798 4.02557C11.0509 4.02557 9.15659 5.91983 9.15659 8.24878C9.15659 9.7444 9.94332 11.053 11.1197 11.8034H5.82933V9.76702H7.39324V10.6962C7.39324 10.971 7.61613 11.1938 7.89142 11.1938C8.1661 11.1938 8.38899 10.971 8.38899 10.6962V9.26939C8.38899 8.99454 8.1661 8.77176 7.89142 8.77176H5.33177C5.05709 8.77176 4.8342 8.99454 4.8342 9.26939V11.8034H3.31837C3.04369 11.8034 2.8208 12.0263 2.8208 12.3011C2.8208 15.4253 4.69872 18.1188 7.38452 19.3133L7.23155 19.3773C6.97746 19.4834 6.85821 19.7749 6.96435 20.0284C7.04362 20.2193 7.22843 20.3342 7.42319 20.3342C7.48754 20.3342 7.55245 20.3218 7.61489 20.2957L8.8273 19.7889C9.36295 19.9079 9.9198 19.9712 10.4911 19.9712H15.1284C15.8052 19.9712 16.4614 19.8827 17.0869 19.7173L18.4704 20.2957C18.5334 20.3219 18.5983 20.3342 18.662 20.3342C18.8569 20.3342 19.0416 20.2192 19.1215 20.0284C19.2277 19.7749 19.1078 19.4834 18.8543 19.3773L18.456 19.211C21.0238 17.9696 22.7987 15.3387 22.7987 12.3011ZM10.1949 8.24878C10.1949 6.4923 11.6233 5.06382 13.3798 5.06382C15.1363 5.06382 16.5648 6.4923 16.5648 8.24878C16.5648 10.0053 15.1363 11.4337 13.3798 11.4337C11.6233 11.4337 10.1949 10.0053 10.1949 8.24878ZM15.1284 18.9759H10.4911C6.97745 18.9759 4.08936 16.2478 3.83401 12.7986H21.7848C21.5295 16.2478 18.6414 18.9759 15.1284 18.9759Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M11.8927 8.72151H12.8974L12.8986 9.76042C12.9108 10.0043 13.112 10.1951 13.3565 10.1951C13.6096 10.1951 13.8156 9.98904 13.8156 9.73605V8.72151L14.8911 8.72031C15.1349 8.70813 15.3258 8.50692 15.3258 8.26245C15.3258 8.0094 15.1197 7.80334 14.8667 7.80334H13.8156L13.8143 6.73701C13.8022 6.49374 13.601 6.30292 13.3565 6.30292C13.1035 6.30292 12.8974 6.50899 12.8974 6.76203V7.80334L11.8664 7.8046C11.6238 7.81798 11.4336 8.01919 11.4336 8.26246C11.4336 8.51545 11.6397 8.72151 11.8927 8.72151Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
    </svg>
  );
};

export default PrivateBathroomIcon;
